/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Round_CountInputs */



/**
* | output |
* | --- |
* | "Number of rounds" |
*
* @param {Tfield_Round_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_round_count = /** @type {((inputs?: Tfield_Round_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Round_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre de rondes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de rondas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Número de rodadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di round")
	return /** @type {LocalizedString} */ ("Number of rounds")
});